/* eslint-disable react/no-array-index-key */
/* eslint-disable no-shadow */
import React, {useEffect, useState, Fragment} from 'react';
import PropTypes from 'prop-types';
import clsx from 'clsx';
import * as Yup from 'yup';
import {Formik} from 'formik';
import {
    Box,
    Button,
    Chip,
    FormHelperText,
    IconButton,
    SvgIcon,
    TextField,
    Typography,
    CardHeader,
    Divider,
    CardContent,
    CircularProgress,
    Grid,
    Checkbox,
    Link,
    Card,
    Avatar,
} from '@mui/material';
import makeStyles from '@mui/styles/makeStyles';
import {Plus as PlusIcon, Star as StarIcon} from 'react-feather';
import { Alert } from '@mui/material';
import {
    GoogleReCaptchaProvider,
    GoogleReCaptcha,
    useGoogleReCaptcha
} from 'react-google-recaptcha-v3';
import wait from "../../../utils/wait";
import {Link as RouterLink} from "react-router-dom";
import axios from "../../../utils/axios";

const useStyles = makeStyles((theme) => ({
    root: {},
    addTab: {
        marginLeft: theme.spacing(2)
    }
}));

function UploadConfirmation({
                                enquiryType,
                                stepName,
                                enquiry,
                                ...rest
                        }) {
    const classes = useStyles();
    const [isAlertVisible, setAlertVisible] = useState(false);
    const [errors, setErrors] = useState({});
    const [status, setStatus] = useState({});
    const [isLoading, setLoading] = useState(true);

    const loadCompleteEnquiry = async (sendCount) => {
        if(sendCount == undefined) {
            sendCount = 1;
        } else {
            sendCount++;
        }

        try {
            let pollingResponse = await axios.get('/web/ui/bulkUser/findEnquiry', {params: {bulkUserUpdateId: enquiry.bulkUserUpdateId}});
            if(pollingResponse.data && pollingResponse.data.ticketId) {
                enquiry.ticketId = pollingResponse.data.ticketId;
                setLoading(false);
            } else if(sendCount <= 20) {
                setTimeout(() => loadCompleteEnquiry(sendCount), 3000);
            } else {
                setErrors({submit: 'Unable to confirm Service Desk enquiry'});
                setAlertVisible(true)
                setLoading(false);
            }
        } catch (err) {
            if(sendCount <= 20) {
                setTimeout(() => loadCompleteEnquiry(sendCount), 3000);
            } else {
                setErrors({submit: 'Unable to confirm Service Desk enquiry - ' + err.message});
                setAlertVisible(true)
                setLoading(false);
            }
        }
    };

    useEffect(() => {
        if (enquiry.bulkUserUpdateId) {
            loadCompleteEnquiry();
        } else {
            setLoading(false);
        }
    }, []);

    return (
        <Card>
            <CardHeader title={enquiryType.title + " - " + stepName} titleTypographyProps={{variant: 'h5', color: 'secondary'}}/>
            <Divider/>
            <CardContent>
                {errors.submit && isAlertVisible &&(
                    <Box mb={3}>
                        <Alert
                            onClose={() => setAlertVisible(false)}
                            severity="info"
                        >
                            {errors.submit}
                        </Alert>
                    </Box>
                )}
                <Box
                    maxWidth={600}
                    mx="auto"
                >
                    <Box
                        display="flex"
                        justifyContent="center"
                    >
                        <Avatar className={classes.avatar}>
                            <StarIcon />
                        </Avatar>
                    </Box>
                    {isLoading && (
                        <Fragment>
                            <Box mt={2}>
                                <Typography
                                    variant="h6"
                                    color="textPrimary"
                                    align="center"
                                >
                                    <p>Your account upload is being processed</p>
                                </Typography>
                            </Box>
                            <Box
                                mt={2}
                                display="flex"
                                justifyContent="center"
                                >
                                <CircularProgress/>
                            </Box>
                        </Fragment>
                    )}

                    {!isLoading && enquiry.ticketId && (
                        <Fragment>
                            <Box mt={2}>
                                <Typography
                                    variant="h6"
                                    color="textPrimary"
                                    align="center"
                                >
                                    Your account upload has been completed.
                                </Typography>
                            </Box>
                            <Box mt={2}>
                                <Typography
                                    variant="subtitle1"
                                    color="textSecondary"
                                    align="center"
                                    paragraph={true}
                                >
                                    Your Service Desk ticket number is <Box component="span" fontWeight="fontWeightBold">{enquiry.ticketId}</Box>.
                                </Typography>
                                <Typography
                                    variant="subtitle1"
                                    color="textSecondary"
                                    align="center"
                                    paragraph={true}
                                >
                                    You will also receive an email from our Service Desk with your ticket number for reference. If you do not receive this, please check your spam/junk mail.
                                </Typography>
                                <Typography
                                    variant="subtitle1"
                                    color="textSecondary"
                                    align="center"
                                    paragraph={true}
                                >
                                    It is also advisable to alert your IT department to <Link href="https://cambridgehelp.zendesk.com/hc/en-us/articles/360039073652-How-can-my-school-unblock-emails-and-domains-required-for-my-Cambridge-digital-resources-?utm_source=servicedesk&utm_medium=website&utm_campaign=whitelist" underline="always" target="_blank"><Box component="span" fontWeight="fontWeightBold">this article</Box></Link> regarding whitelisted domains and addresses to ensure all communication from our service desk is received.
                                </Typography>
                            </Box>
                        </Fragment>
                    )}
                    <Box
                        mt={2}
                        display="flex"
                        justifyContent="center"
                    >
                        <Button
                            variant="contained"
                            color="secondary"
                            component={RouterLink}
                            to="/app/service"
                        >
                            Another Enquiry
                        </Button>
                    </Box>
                </Box>
            </CardContent>
        </Card>
    );
}

UploadConfirmation.propTypes = {
    enquiryType: PropTypes.object,
    stepName: PropTypes.string,
    enquiry: PropTypes.object
};

export default UploadConfirmation;
